export default __webpack_public_path__ + "static/media/36I-102783_-15893_0.de1aee0d.jpg";